import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { authGuard } from 'src/app/auth/auth-guard.service';

const routes: Routes = [
  {
    path: 'donor-care-report',
    loadComponent: () => import('./donor-care-report/donor-care-report.component').then(m => m.DonorCareReportComponent),
    canActivate: [authGuard()],
    title: 'Donor Care Report | Mission Control'
  },
  {
    path: 'updates',
    loadComponent: () => import('./ppm365-updates/ppm365-updates.component').then(m => m.Ppm365UpdatesComponent),
    canActivate: [authGuard()],
    title: 'PPM365 Updates | Mission Control'
  }
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class Ppm365RoutingModule { } 